function normalizeLocale(input) {
  if (!input || typeof input !== "string") return null;

  const [lang, region] = input.replace(/_/g, "-").split("-");
  if (!lang) return null;

  if (!region) {
    return lang.toLowerCase();
  }

  return `${lang.toLowerCase()}-${region.toUpperCase()}`;
}

const BASE_LANGUAGE_DEFAULTS = {
  ar: "ar-SA",
  be: "be-BY",
  bg: "bg-BG",
  bn: "bn-IN",
  ca: "ca-ES",
  cs: "cs-CZ",
  da: "da-DK",
  de: "de-DE",
  el: "el-GR",
  en: "en-US",
  es: "es-ES",
  fa: "fa-IR",
  fi: "fi-FI",
  fr: "fr-FR",
  he: "he-IL",
  hi: "hi-IN",
  hr: "hr-HR",
  hu: "hu-HU",
  id: "id-ID",
  is: "is-IS",
  it: "it-IT",
  ja: "ja-JP",
  kk: "kk-KZ",
  ko: "ko-KR",
  mn: "mn-MN",
  ms: "ms-MY",
  nb: "nb-NO",
  nl: "nl-NL",
  pl: "pl-PL",
  pt: "pt-BR",
  ro: "ro-RO",
  ru: "ru-RU",
  sk: "sk-SK",
  sr: "sr-RS",
  sv: "sv-SE",
  ta: "ta-IN",
  te: "te-IN",
  th: "th-TH",
  tr: "tr-TR",
  uk: "uk-UA",
  vi: "vi-VN",
  zh: "zh-CN",
};

const LOCALE_LOADERS = {
  "en-US": () => import("@clerk/localizations/en-US").then((m) => m.enUS),
  "en-GB": () => import("@clerk/localizations/en-GB").then((m) => m.enGB),
  "ar-SA": () => import("@clerk/localizations/ar-SA").then((m) => m.arSA),
  "be-BY": () => import("@clerk/localizations/be-BY").then((m) => m.beBY),
  "bg-BG": () => import("@clerk/localizations/bg-BG").then((m) => m.bgBG),
  "bn-IN": () => import("@clerk/localizations/bn-IN").then((m) => m.bnIN),
  "ca-ES": () => import("@clerk/localizations/ca-ES").then((m) => m.caES),
  "cs-CZ": () => import("@clerk/localizations/cs-CZ").then((m) => m.csCZ),
  "da-DK": () => import("@clerk/localizations/da-DK").then((m) => m.daDK),
  "de-DE": () => import("@clerk/localizations/de-DE").then((m) => m.deDE),
  "el-GR": () => import("@clerk/localizations/el-GR").then((m) => m.elGR),
  "es-CR": () => import("@clerk/localizations/es-CR").then((m) => m.esCR),
  "es-ES": () => import("@clerk/localizations/es-ES").then((m) => m.esES),
  "es-MX": () => import("@clerk/localizations/es-MX").then((m) => m.esMX),
  "es-UY": () => import("@clerk/localizations/es-UY").then((m) => m.esUY),
  "fa-IR": () => import("@clerk/localizations/fa-IR").then((m) => m.faIR),
  "fi-FI": () => import("@clerk/localizations/fi-FI").then((m) => m.fiFI),
  "fr-FR": () => import("@clerk/localizations/fr-FR").then((m) => m.frFR),
  "he-IL": () => import("@clerk/localizations/he-IL").then((m) => m.heIL),
  "hi-IN": () => import("@clerk/localizations/hi-IN").then((m) => m.hiIN),
  "hr-HR": () => import("@clerk/localizations/hr-HR").then((m) => m.hrHR),
  "hu-HU": () => import("@clerk/localizations/hu-HU").then((m) => m.huHU),
  "id-ID": () => import("@clerk/localizations/id-ID").then((m) => m.idID),
  "is-IS": () => import("@clerk/localizations/is-IS").then((m) => m.isIS),
  "it-IT": () => import("@clerk/localizations/it-IT").then((m) => m.itIT),
  "ja-JP": () => import("@clerk/localizations/ja-JP").then((m) => m.jaJP),
  "kk-KZ": () => import("@clerk/localizations/kk-KZ").then((m) => m.kkKZ),
  "ko-KR": () => import("@clerk/localizations/ko-KR").then((m) => m.koKR),
  "mn-MN": () => import("@clerk/localizations/mn-MN").then((m) => m.mnMN),
  "ms-MY": () => import("@clerk/localizations/ms-MY").then((m) => m.msMY),
  "nb-NO": () => import("@clerk/localizations/nb-NO").then((m) => m.nbNO),
  "nl-BE": () => import("@clerk/localizations/nl-BE").then((m) => m.nlBE),
  "nl-NL": () => import("@clerk/localizations/nl-NL").then((m) => m.nlNL),
  "pl-PL": () => import("@clerk/localizations/pl-PL").then((m) => m.plPL),
  "pt-BR": () => import("@clerk/localizations/pt-BR").then((m) => m.ptBR),
  "pt-PT": () => import("@clerk/localizations/pt-PT").then((m) => m.ptPT),
  "ro-RO": () => import("@clerk/localizations/ro-RO").then((m) => m.roRO),
  "ru-RU": () => import("@clerk/localizations/ru-RU").then((m) => m.ruRU),
  "sk-SK": () => import("@clerk/localizations/sk-SK").then((m) => m.skSK),
  "sr-RS": () => import("@clerk/localizations/sr-RS").then((m) => m.srRS),
  "sv-SE": () => import("@clerk/localizations/sv-SE").then((m) => m.svSE),
  "ta-IN": () => import("@clerk/localizations/ta-IN").then((m) => m.taIN),
  "te-IN": () => import("@clerk/localizations/te-IN").then((m) => m.teIN),
  "th-TH": () => import("@clerk/localizations/th-TH").then((m) => m.thTH),
  "tr-TR": () => import("@clerk/localizations/tr-TR").then((m) => m.trTR),
  "uk-UA": () => import("@clerk/localizations/uk-UA").then((m) => m.ukUA),
  "vi-VN": () => import("@clerk/localizations/vi-VN").then((m) => m.viVN),
  "zh-CN": () => import("@clerk/localizations/zh-CN").then((m) => m.zhCN),
  "zh-TW": () => import("@clerk/localizations/zh-TW").then((m) => m.zhTW),
};

const PRIMARY_FALLBACK_LOCALE = "it-IT";
const SECONDARY_FALLBACK_LOCALE = "en-US";

function getLocaleCandidates(browserLanguages) {
  const ordered = [];
  const seen = new Set();
  const rawCandidates = Array.isArray(browserLanguages) && browserLanguages.length
    ? browserLanguages
    : [typeof navigator !== "undefined" ? navigator.language : SECONDARY_FALLBACK_LOCALE];

  const add = (code) => {
    if (!code || seen.has(code)) return;
    seen.add(code);
    ordered.push(code);
  };

  for (const raw of rawCandidates) {
    const normalized = normalizeLocale(raw);
    if (!normalized) continue;

    if (LOCALE_LOADERS[normalized]) {
      add(normalized);
      continue;
    }

    const baseLang = normalized.split("-")[0];
    add(BASE_LANGUAGE_DEFAULTS[baseLang]);
  }

  add(PRIMARY_FALLBACK_LOCALE);
  add(SECONDARY_FALLBACK_LOCALE);

  return ordered;
}

export async function loadBrowserClerkLocalization() {
  const candidates = getLocaleCandidates(
    typeof navigator !== "undefined" ? navigator.languages : undefined
  );

  for (const code of candidates) {
    const loader = LOCALE_LOADERS[code];
    if (!loader) continue;

    try {
      const localization = await loader();
      return { code, localization };
    } catch (error) {
      console.warn(`[Clerk] Failed to load localization ${code}`, error);
    }
  }

  return { code: undefined, localization: undefined };
}

